import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    Aangifte,
    AangifteBerekening,
    AangifteRapport, BokkzAlgDataService,
    BokkzClient,
    BokkzIbDataService,
    IbRekenService,
    IncomeTaxEntity, OpbouwBox3, SpecificatieBox3
} from '@snelstart-ventures/fiscaal/domain-logic';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors } from '@angular/forms';
import { filter, forkJoin, Observable, Subscription } from 'rxjs';
import { Event, NavigationEnd, Router } from '@angular/router';
import { ToastService } from '@snelstart/ui-toast';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiAlertModule } from '@snelstart/ui-alert';
import { CommonModule, DecimalPipe } from '@angular/common';
import { SharedUiLoadingModule } from '@snelstart/ui-loading';


@Component({
    selector: 'snelstart-venture-fiscaal-feature-verdeling',
    templateUrl: './verdeling.component.html',
    styleUrls: ['./verdeling.component.scss'],
    imports: [
        SharedUiFormControlsModule,
        SharedUiDetailsModule,
        SharedUiButtonModule,
        SharedUiAlertModule,
        DecimalPipe,
        SharedUiLoadingModule,
        CommonModule
    ]
})
export class VerdelingComponent implements OnInit, OnDestroy {

    private incomeTaxEntitySubscription = {} as Subscription;
    private clientEntitySubscription = {} as Subscription;
    private routerSubscription: Subscription | undefined;
    private hasVerdelingGezienSubscribtion: Subscription | undefined;
    private optimaleAangifeSubscription: Subscription | undefined;
    private optimaleBerekeningSubscription: Subscription | undefined;
    private aantalValidatiesSubscription: Subscription | undefined;
    public clientId!: string;

    private isSaving = false;
    aangifte = {} as Aangifte;
    optimaleAangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    public hasVerdelingGezien = false;
    public aantalValidaties = 0;
    public spinnerOptimalisatie = false;

    public totaalEigenwoningVerdeling = 0;
    public totaalGOGEWSVerdeling = 0;
    public totaalBox2Verdeling = 0;
    public totaalBox3Verdeling = 0;
    public totaalPGAVerdeling = 0;
    public totaalDividendbelastingVerdeling = 0;

    specBox3 = {} as AangifteRapport;
    specBox3FormGroup = this.fb.group<AangifteRapport>({});
    vermogensGrensVoorRegelingen: any;

    private toonVoorstelKnopValue = false;
    private toonVoorstelTimeout?: ReturnType<typeof setTimeout>;

    public optimaleVerdelingFg = this.fb.group({
        totaalEigenWoning: null as unknown as number,
        totaalGOGEWS: null as unknown as number,
        totaalBox2: null as unknown as number,
        totaalBox3: null as unknown as number,
        totaalPGA: null as unknown as number,
        totaalDividendbelasting: null as unknown as number,

        aandeelEigenWoningAangever: [null as unknown as number, [this.maxEigenWoningValidator()]],
        aandeelGOGEWSAangever: null as unknown as number,
        aandeelBox2Aangever: [null as unknown as number, [this.maxBox2Validator()]],
        aandeelBox3Aangever: [null as unknown as number, [this.maxBox3Validator()]],
        aandeelPGAAangever: [null as unknown as number, [this.maxPGAValidator()]],
        aandeelDividendbelastingAangever: [null as unknown as number, [this.maxDividendBelastingValidator()]],

        aandeelEigenWoningPartner: null as unknown as number,
        aandeelGOGEWSPartner: null as unknown as number,
        aandeelBox2Partner: null as unknown as number,
        aandeelBox3Partner: null as unknown as number,
        aandeelPGAPartner: null as unknown as number,
        aandeelDividendbelastingPartner: null as unknown as number,

        totaalRendementsgrondslagA: null as unknown as number,
        aandeelRendementsgrondslagAangever: [null as unknown as number, [this.maxBox3Validator()]],
        aandeelRendementsgrondslagPartner: null as unknown as number

    });
    public gekozenVerdelingFg = this.fb.group({
        totaalEigenWoning: null as unknown as number,
        totaalGOGEWS: null as unknown as number,
        totaalBox2: null as unknown as number,
        totaalBox3: null as unknown as number,
        totaalPGA: null as unknown as number,
        totaalDividendbelasting: null as unknown as number,

        aandeelEigenWoningAangever: [null as unknown as number, [this.maxEigenWoningValidator()]],
        aandeelGOGEWSAangever: null as unknown as number,
        aandeelBox2Aangever: [null as unknown as number, [this.maxBox2Validator()]],
        aandeelBox3Aangever: [null as unknown as number, [this.maxBox3Validator()]],
        aandeelPGAAangever: [null as unknown as number, [this.maxPGAValidator()]],
        aandeelDividendbelastingAangever: [null as unknown as number, [this.maxDividendBelastingValidator()]],

        aandeelEigenWoningPartner: null as unknown as number,
        aandeelGOGEWSPartner: null as unknown as number,
        aandeelBox2Partner: null as unknown as number,
        aandeelBox3Partner: null as unknown as number,
        aandeelPGAPartner: null as unknown as number,
        aandeelDividendbelastingPartner: null as unknown as number,

        totaalRendementsGrondslag: null as unknown as number,
        aandeelRendementsGrondslagAangever: null as unknown as number,
        aandeelRendementsGrondslagPartner: null as unknown as number
    });

    public berekeningFg = this.fb.group({
        verschuldigdeInkomstenbelastingGezamenlijkOptimaal: null as unknown as number,
        verschuldigdeInkomstenbelastingAangeverOptimaal: null as unknown as number,
        verschuldigdeInkomstenbelastingPartnerOptimaal: null as unknown as number,
        verschuldigdeInkomstenbelastingAangeverGekozen: null as unknown as number,
        verschuldigdeInkomstenbelastingPartnerGekozen: null as unknown as number,
        verschuldigdeInkomstenbelastingGezamenlijkGekozen: null as unknown as number,
        gezamenlijkBedragAanslagen: null as unknown as number,
        gezamenlijkBedragGekozen: null as unknown as number
    });
    public berekening = {} as AangifteBerekening;
    public optimaleBerekening = {} as AangifteBerekening;
    public totaalVerschuldigdIb = 0;
    public totaalVerschuldigdIbOptimaal = 0;
    public spinnerOnInit = true;

    public rendementsGrondslagFormGroup = this.fb.group({
        rendementsGrondslag: null as unknown as number,
        aandeelRendementsGrondslagVoorRegelingenAangever: [
            this.aangifte.verdeling?.aandeelRendementsGrondslag ?? null,
            [this.maxBox3RendementsgrondslagValidator()]
        ],
        aandeelRendementsGrondslagVoorRegelingenPartner: [
            this.aangifte.partnerAangifte?.verdeling?.aandeelRendementsGrondslag ?? null,
            [this.maxBox3RendementsgrondslagValidator()]
        ]
    });

    constructor(private fb: FormBuilder,
                private bokkzIbRekenservice: IbRekenService,
                private router: Router,
                public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
                private bokkzClient: BokkzClient,
                public toastService: ToastService
    ) {
        this.berekeningFg = this.fb.group({
            verschuldigdeInkomstenbelastingGezamenlijkOptimaal: [0],
            verschuldigdeInkomstenbelastingAangeverOptimaal: [0],
            verschuldigdeInkomstenbelastingPartnerOptimaal: [0],
            verschuldigdeInkomstenbelastingAangeverGekozen: null as unknown as number,
            verschuldigdeInkomstenbelastingPartnerGekozen: null as unknown as number,
            verschuldigdeInkomstenbelastingGezamenlijkGekozen: null as unknown as number,
            gezamenlijkBedragAanslagen: null as unknown as number,
            gezamenlijkBedragGekozen: null as unknown as number
        });
        this.specBox3FormGroup = this.fb.group<AangifteRapport>(({
            specificatieBox3: this.fb.group<SpecificatieBox3>(({
                opbouw: this.fb.group<OpbouwBox3>({
                    verminderingVoordeelSparenEnBeleggen: null as unknown as number,
                    voordeelSparenEnBeleggenVoorVermindering: null as unknown as number,
                    tijdsEvenredigeVermindering: null as unknown as number,
                    grondslagSparenEnBeleggen: null as unknown as number,
                    heffingsvrijVermogenAangever: null as unknown as number,
                    heffingsvrijVermogenPartner: null as unknown as number,
                    rendementsGrondslag: null as unknown as number
                })
            } as SpecificatieBox3))
        } as AangifteRapport));
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.gekozenVerdelingFg.dirty;
    }

    public hasEigenWoningen(): boolean {
        return !!(this.aangifte &&
            this.aangifte.box1 &&
            this.aangifte.box1.belastbareInkomstenUitEigenWoning &&
            this.aangifte.box1.belastbareInkomstenUitEigenWoning.eigenWoningen &&
            this.aangifte.box1.belastbareInkomstenUitEigenWoning.eigenWoningen.length > 0);
    }

    createTotalenOptimaleVerdeling(optimaleAangifte: Aangifte) {
        const aandeelEigenWoningAangever = optimaleAangifte?.verdeling?.aandeelEigenWoning || 0;
        const aandeelGOGEWSAangever = this.optimaleBerekening.box1?.opbouwInkomen?.aftrekWegensGeenOfGeringeEigenWoningSchuld || 0;
        const aandeelBox2Aangever = optimaleAangifte?.verdeling?.aandeelBox2 || 0;
        const aandeelBox3Aangever = optimaleAangifte?.verdeling?.aandeelBox3 || 0;
        const aandeelPGAAangever = optimaleAangifte?.verdeling?.aandeelPGA || 0;
        const aandeelDividendbelastingAangever = optimaleAangifte?.verdeling?.aandeelDividendbelasting || 0;

        const aandeelEigenWoningPartner = optimaleAangifte?.partnerAangifte?.verdeling?.aandeelEigenWoning || 0;
        const aandeelGOGEWSPartner = this.optimaleBerekening.partnerBerekening?.box1?.opbouwInkomen?.aftrekWegensGeenOfGeringeEigenWoningSchuld || 0;
        const aandeelBox2Partner = optimaleAangifte?.partnerAangifte?.verdeling?.aandeelBox2 || 0;
        const aandeelBox3Partner = optimaleAangifte?.partnerAangifte?.verdeling?.aandeelBox3 || 0;
        const aandeelPGAPartner = optimaleAangifte?.partnerAangifte?.verdeling?.aandeelPGA || 0;
        const aandeelDividendbelastingPartner = optimaleAangifte?.partnerAangifte?.verdeling?.aandeelDividendbelasting || 0;

        this.totaalEigenwoningVerdeling = aandeelEigenWoningAangever + aandeelEigenWoningPartner;
        this.totaalGOGEWSVerdeling = aandeelGOGEWSAangever + aandeelGOGEWSPartner;
        this.totaalBox2Verdeling = aandeelBox2Aangever + aandeelBox2Partner;
        this.totaalBox3Verdeling = aandeelBox3Aangever + aandeelBox3Partner;
        this.totaalPGAVerdeling = aandeelPGAAangever + aandeelPGAPartner;
        this.totaalDividendbelastingVerdeling = aandeelDividendbelastingAangever + aandeelDividendbelastingPartner;

    }

    public ngOnInit(): void {
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                this.berekeningFg.reset();
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.dataService.aangifteRapport.subscribe((value) => {
                    this.specBox3FormGroup.reset();
                    this.specBox3 = value;
                    this.specBox3FormGroup.patchValue(this.specBox3);
                    this.rendementsGrondslagFormGroup.patchValue({
                        rendementsGrondslag: this.specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value,
                        aandeelRendementsGrondslagVoorRegelingenAangever: this.aangifte?.verdeling?.aandeelRendementsGrondslag,
                        aandeelRendementsGrondslagVoorRegelingenPartner: this.aangifte?.partnerAangifte?.verdeling?.aandeelRendementsGrondslag
                    });
                });
                const observables = [
                    this.bokkzClient.getIbBerekening(aangifte),
                    this.bokkzClient.getIbOptimalisatie(aangifte)
                ];
                forkJoin(observables).subscribe(([berekening, optimaleAangifte]) => {
                    this.berekening = berekening as AangifteBerekening;
                    if (this.berekening.partnerBerekening != undefined) {
                        this.dataService.updateAangifteBerekening(this.berekening);
                        this.dataService.updatePartnerAangifteBerekening(this.berekening.partnerBerekening);
                        if (aangifte.verdeling!= null && (aangifte.verdeling.aandeelEigenWoning!= null || aangifte.verdeling.aandeelBox2!= null ||
                            aangifte.verdeling.aandeelBox3!= null || aangifte.verdeling.aandeelRendementsGrondslag!= null || aangifte.verdeling.aandeelDividendbelasting!= null)) {
                            this.patchAangifteVerdelingUitAangifte();
                        }
                        this.optimaleAangifte = optimaleAangifte as Aangifte;
                        this.dataService.updateOptimaleAangifte(this.optimaleAangifte);
                        const optimaleBerekeningObservable: Observable<AangifteBerekening> = this.bokkzClient.getIbBerekening(optimaleAangifte as Aangifte);
                        forkJoin({
                            optimaleBerekening: optimaleBerekeningObservable
                        }).subscribe(({ optimaleBerekening }) => {
                                this.optimaleBerekening = optimaleBerekening as AangifteBerekening;
                                this.dataService.updateOptimaleBerekening(optimaleBerekening);
                                this.createTotalenOptimaleVerdeling(optimaleAangifte as Aangifte);
                                this.patchOptimaleVerdeling(optimaleAangifte as Aangifte);
                                this.createVerschuldigeIbOptimaal();
                                if (!this.hasVerdelingGezien) {
                                    this.patchOptimaleVerdeling(optimaleAangifte as Aangifte);
                                    // this.resetVerdelingGekozenFg();
                                }
                                if (this.hasVerdelingGezien) {
                                    this.patchAangifteVerdelingUitAangifte();
                                }
                                this.spinnerOnInit = false;
                            }
                        );
                    } else if (aangifte.gezamenlijkeAangifte === false) {
                        this.spinnerOnInit = false;
                    }
                });
            }
        });
        this.hasVerdelingGezienSubscribtion = this.dataService.hasVerdelingGezien.subscribe((gezien) => {
            this.hasVerdelingGezien = gezien;
        });
        this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) => {
            this.clientId = client.sstRelationId!;
        });
        this.routerSubscription = this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            this.handleUrlChange(event.urlAfterRedirects);
        });
        this.optimaleAangifeSubscription = this.dataService.optimaleAangifte.subscribe((optimaleAangifte) => {
            if (optimaleAangifte.verdeling) {
                this.optimaleAangifte = optimaleAangifte;
            }
        });
        this.optimaleBerekeningSubscription = this.dataService.optimaleBerekening.subscribe((optimaleBerekening) => {
            this.optimaleBerekening = optimaleBerekening;
        });
        this.aantalValidatiesSubscription = this.dataService.aantalValidaties.subscribe((aantalValidaties) => {
            this.aantalValidaties = aantalValidaties;
        });

        if (this.aangifte.aangifteJaar === 2024) {
            this.vermogensGrensVoorRegelingen = 73904;
            this.berekenRendementsGrondslagRegelingen();
        } else if (this.aangifte.aangifteJaar === 2025) {
            this.vermogensGrensVoorRegelingen = 74790;
            this.berekenRendementsGrondslagRegelingen();
        } else if (this.aangifte.aangifteJaar === 2026) {
            this.vermogensGrensVoorRegelingen = 76958;
            this.berekenRendementsGrondslagRegelingen();
        }
        this.disableFormGroup(this.berekeningFg);
    }

    ngOnDestroy() {
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe();
        }
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
        if (this.hasVerdelingGezienSubscribtion) {
            this.hasVerdelingGezienSubscribtion.unsubscribe();
        }
        if (this.optimaleBerekeningSubscription) {
            this.optimaleBerekeningSubscription.unsubscribe();
        }
        if (this.optimaleAangifeSubscription) {
            this.optimaleAangifeSubscription.unsubscribe();
        }
        if (this.aantalValidatiesSubscription) {
            this.aantalValidatiesSubscription.unsubscribe();
        }
        if (this.toonVoorstelTimeout) {
            clearTimeout(this.toonVoorstelTimeout);
        }

    }

    saveForm() {
        if (this.gekozenVerdelingFg.valid) {
            const aangeverGekozenEW = this.gekozenVerdelingFg.value['aandeelEigenWoningAangever'] || 0;
            const aangeverGekozenGOGEWS = this.gekozenVerdelingFg.value['aandeelGOGEWSAangever'] || 0;
            const aangeverGekozenBox2 = this.gekozenVerdelingFg.value['aandeelBox2Aangever'] || 0;
            const aangeverGekozenBox3 = this.gekozenVerdelingFg.value['aandeelBox3Aangever'] || 0;
            const aangeverGekozenPGA = this.gekozenVerdelingFg.value['aandeelPGAAangever'] || 0;
            const aangeverGekozenDividendBelasting = this.gekozenVerdelingFg.value['aandeelDividendbelastingAangever'] || 0;
            const totaalEigenwoningVerdeling = this.totaalEigenwoningVerdeling;
            const totaalGOGEWSVerdeling = this.totaalGOGEWSVerdeling;
            const totaalBox2Verdeling = this.totaalBox2Verdeling;
            const totaalBox3Verdeling = this.totaalBox3Verdeling;
            const totaalPGAVerdeling = this.totaalPGAVerdeling;
            const totaalDividendbelastingVerdeling = this.totaalDividendbelastingVerdeling;

            this.gekozenVerdelingFg.patchValue({
                aandeelEigenWoningAangever: aangeverGekozenEW || 0,
                aandeelGOGEWSAangever: aangeverGekozenGOGEWS || 0,
                aandeelBox2Aangever: aangeverGekozenBox2 || 0,
                aandeelBox3Aangever: aangeverGekozenBox3 || 0,
                aandeelPGAAangever: aangeverGekozenPGA || 0,
                aandeelDividendbelastingAangever: aangeverGekozenDividendBelasting || 0,

                aandeelEigenWoningPartner: totaalEigenwoningVerdeling - aangeverGekozenEW,
                aandeelGOGEWSPartner: totaalGOGEWSVerdeling - aangeverGekozenGOGEWS,
                aandeelBox2Partner: totaalBox2Verdeling - aangeverGekozenBox2,
                aandeelBox3Partner: totaalBox3Verdeling - aangeverGekozenBox3,
                aandeelPGAPartner: totaalPGAVerdeling - aangeverGekozenPGA,
                aandeelDividendbelastingPartner: totaalDividendbelastingVerdeling - aangeverGekozenDividendBelasting
            });

            const totaalGekozenRendementsGrondslag = this.rendementsGrondslagFormGroup.get('rendementsGrondslag')?.value || 0;
            const aangeverGekozenRendementsGrondslag = this.rendementsGrondslagFormGroup.get('aandeelRendementsGrondslagVoorRegelingenAangever')?.value || 0;
            const partnerGekozenRendementsGrondslag = totaalGekozenRendementsGrondslag - aangeverGekozenRendementsGrondslag || 0;

            const eigenAangifte = {
                ...this.aangifte,
                verdeling: {
                    ['aandeelEigenWoning']: aangeverGekozenEW,
                    ['aandeelGOGEWS']: aangeverGekozenGOGEWS,
                    ['aandeelBox2']: aangeverGekozenBox2,
                    ['aandeelBox3']: aangeverGekozenBox3,
                    ['aandeelPGA']: aangeverGekozenPGA,
                    ['aandeelDividendbelasting']: aangeverGekozenDividendBelasting,
                    ['aandeelRendementsGrondslag']: aangeverGekozenRendementsGrondslag
                },
                partnerAangifte: {
                    ...this.aangifte.partnerAangifte,
                    verdeling: {
                        ['aandeelEigenWoning']: totaalEigenwoningVerdeling - aangeverGekozenEW,
                        ['aandeelGOGEWS']: totaalGOGEWSVerdeling - aangeverGekozenGOGEWS,
                        ['aandeelBox2']: totaalBox2Verdeling - aangeverGekozenBox2,
                        ['aandeelBox3']: totaalBox3Verdeling - aangeverGekozenBox3,
                        ['aandeelPGA']: totaalPGAVerdeling - aangeverGekozenPGA,
                        ['aandeelDividendbelasting']: totaalDividendbelastingVerdeling - aangeverGekozenDividendBelasting,
                        ['aandeelRendementsGrondslag']: partnerGekozenRendementsGrondslag
                    }
                }
            } as Aangifte;
            const aangifteBerekening = this.bokkzIbRekenservice.getIncomeTaxCalculation(eigenAangifte);
            aangifteBerekening.subscribe((aangifteBerekening) => {
                const aangever = aangifteBerekening.verschuldigdeInkomstenbelasting || 0;
                const partner = aangifteBerekening.partnerBerekening?.verschuldigdeInkomstenbelasting || 0;
                this.totaalVerschuldigdIb = aangever + partner;
                this.berekeningFg.patchValue({
                        verschuldigdeInkomstenbelastingAangeverGekozen: aangever,
                        verschuldigdeInkomstenbelastingPartnerGekozen: partner,
                        verschuldigdeInkomstenbelastingGezamenlijkGekozen: aangever + partner
                    }
                );
            });
            this.dataService.updateHasVerdelingGezien(true);
            this.incomeTaxEntity.aangifte = eigenAangifte;
            const aandeelAangever = this.rendementsGrondslagFormGroup.get('aandeelRendementsGrondslagVoorRegelingenAangever')?.value || 0;
            const aandeelPartner = this.rendementsGrondslagFormGroup.get('aandeelRendementsGrondslagVoorRegelingenPartner')?.value || 0;

            this.specBox3FormGroup.patchValue({
                specificatieBox3: {
                    opbouw: {
                        aandeelRendementsGrondslagVoorRegelingenAangever: aandeelAangever,
                        aandeelRendementsGrondslagVoorRegelingenPartner: aandeelPartner
                    }
                }
            });
            this.controleerRendementsGrondslag();
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        }
    }

    patchOptimaleVerdeling(optimaleAangifte: Aangifte) {
        const aandeelEigenWoningAangever = optimaleAangifte?.verdeling?.aandeelEigenWoning || 0;
        const aandeelGOGEWSAangever = this.optimaleBerekening.box1?.opbouwInkomen?.aftrekWegensGeenOfGeringeEigenWoningSchuld || 0;
        const aandeelBox2Aangever = optimaleAangifte?.verdeling?.aandeelBox2 || 0;
        const aandeelBox3Aangever = optimaleAangifte?.verdeling?.aandeelBox3 || 0;
        const aandeelPGAAangever = optimaleAangifte?.verdeling?.aandeelPGA || 0;
        const aandeelDividendbelastingAangever = optimaleAangifte?.verdeling?.aandeelDividendbelasting || 0;

        const aandeelEigenWoningPartner = optimaleAangifte?.partnerAangifte?.verdeling?.aandeelEigenWoning || 0;
        const aandeelGOGEWSPartner = this.optimaleBerekening.partnerBerekening?.box1?.opbouwInkomen?.aftrekWegensGeenOfGeringeEigenWoningSchuld || 0;
        const aandeelBox2Partner = optimaleAangifte?.partnerAangifte?.verdeling?.aandeelBox2 || 0;
        const aandeelBox3Partner = optimaleAangifte?.partnerAangifte?.verdeling?.aandeelBox3 || 0;
        const aandeelPGAPartner = optimaleAangifte?.partnerAangifte?.verdeling?.aandeelPGA || 0;
        const aandeelDividendbelastingPartner = optimaleAangifte?.partnerAangifte?.verdeling?.aandeelDividendbelasting || 0;

        this.totaalEigenwoningVerdeling = aandeelEigenWoningAangever + aandeelEigenWoningPartner;
        this.totaalGOGEWSVerdeling = aandeelGOGEWSAangever + aandeelGOGEWSPartner;
        this.totaalBox2Verdeling = aandeelBox2Aangever + aandeelBox2Partner;
        this.totaalBox3Verdeling = aandeelBox3Aangever + aandeelBox3Partner;
        this.totaalPGAVerdeling = aandeelPGAAangever + aandeelPGAPartner;
        this.totaalDividendbelastingVerdeling = aandeelDividendbelastingAangever + aandeelDividendbelastingPartner;

        this.optimaleVerdelingFg.patchValue({
            totaalEigenWoning: this.totaalEigenwoningVerdeling,
            totaalGOGEWS: this.totaalGOGEWSVerdeling,
            totaalBox2: this.totaalBox2Verdeling,
            totaalBox3: this.totaalBox3Verdeling,
            totaalPGA: this.totaalPGAVerdeling,
            totaalDividendbelasting: this.totaalDividendbelastingVerdeling,

            aandeelEigenWoningAangever: aandeelEigenWoningAangever,
            aandeelGOGEWSAangever: aandeelGOGEWSAangever,
            aandeelBox2Aangever: aandeelBox2Aangever,
            aandeelBox3Aangever: aandeelBox3Aangever,
            aandeelPGAAangever: aandeelPGAAangever,
            aandeelDividendbelastingAangever: aandeelDividendbelastingAangever,

            aandeelEigenWoningPartner: aandeelEigenWoningPartner,
            aandeelGOGEWSPartner: aandeelGOGEWSPartner,
            aandeelBox2Partner: aandeelBox2Partner,
            aandeelBox3Partner: aandeelBox3Partner,
            aandeelPGAPartner: aandeelPGAPartner,
            aandeelDividendbelastingPartner: aandeelDividendbelastingPartner
        });
        this.gekozenVerdelingFg.patchValue({
            totaalEigenWoning: this.totaalEigenwoningVerdeling,
            totaalGOGEWS: this.totaalGOGEWSVerdeling,
            totaalBox2: this.totaalBox2Verdeling,
            totaalBox3: this.totaalBox3Verdeling,
            totaalPGA: this.totaalPGAVerdeling,
            totaalDividendbelasting: this.totaalDividendbelastingVerdeling
        });

    }

    patchGekozenVerdelingMetOptimaleVerdeling() {
        const aandeelEigenWoningAangever = this.optimaleAangifte?.verdeling?.aandeelEigenWoning || 0;
        const aandeelGOGEWSAangever = this.optimaleBerekening?.box1?.opbouwInkomen?.aftrekWegensGeenOfGeringeEigenWoningSchuld || 0;
        const aandeelBox2Aangever = this.optimaleAangifte?.verdeling?.aandeelBox2 || 0;
        const aandeelBox3Aangever = this.optimaleAangifte?.verdeling?.aandeelBox3 || 0;
        const aandeelPGAAangever = this.optimaleAangifte?.verdeling?.aandeelPGA || 0;
        const aandeelDividendbelastingAangever = this.optimaleAangifte?.verdeling?.aandeelDividendbelasting || 0;

        const aandeelEigenWoningPartner = this.optimaleAangifte?.partnerAangifte?.verdeling?.aandeelEigenWoning || 0;
        const aandeelGOGEWSPartner = this.optimaleBerekening?.partnerBerekening?.box1?.opbouwInkomen?.aftrekWegensGeenOfGeringeEigenWoningSchuld || 0;
        const aandeelBox2Partner = this.optimaleAangifte?.partnerAangifte?.verdeling?.aandeelBox2 || 0;
        const aandeelBox3Partner = this.optimaleAangifte?.partnerAangifte?.verdeling?.aandeelBox3 || 0;
        const aandeelPGAPartner = this.optimaleAangifte?.partnerAangifte?.verdeling?.aandeelPGA || 0;
        const aandeelDividendbelastingPartner = this.optimaleAangifte?.partnerAangifte?.verdeling?.aandeelDividendbelasting || 0;

        this.totaalEigenwoningVerdeling = aandeelEigenWoningAangever + aandeelEigenWoningPartner;
        this.totaalGOGEWSVerdeling = aandeelGOGEWSAangever + aandeelGOGEWSPartner;
        this.totaalBox2Verdeling = aandeelBox2Aangever + aandeelBox2Partner;
        this.totaalBox3Verdeling = aandeelBox3Aangever + aandeelBox3Partner;
        this.totaalPGAVerdeling = aandeelPGAAangever + aandeelPGAPartner;
        this.totaalDividendbelastingVerdeling = aandeelDividendbelastingAangever + aandeelDividendbelastingPartner;

        const aandeelRendementsGrondslagAangever = this.optimaleAangifte?.verdeling?.aandeelRendementsGrondslag || 0;
        const aandeelRendementsGrondslagPartner = this.optimaleAangifte?.partnerAangifte?.verdeling?.aandeelRendementsGrondslag || 0;

        this.gekozenVerdelingFg.patchValue({
            totaalEigenWoning: this.totaalEigenwoningVerdeling,
            totaalGOGEWS: this.totaalGOGEWSVerdeling,
            totaalBox2: this.totaalBox2Verdeling,
            totaalBox3: this.totaalBox3Verdeling,
            totaalPGA: this.totaalPGAVerdeling,
            totaalDividendbelasting: this.totaalDividendbelastingVerdeling,

            aandeelEigenWoningAangever: aandeelEigenWoningAangever,
            aandeelGOGEWSAangever: aandeelGOGEWSAangever,
            aandeelBox2Aangever: aandeelBox2Aangever,
            aandeelBox3Aangever: aandeelBox3Aangever,
            aandeelPGAAangever: aandeelPGAAangever,
            aandeelDividendbelastingAangever: aandeelDividendbelastingAangever,

            aandeelEigenWoningPartner: aandeelEigenWoningPartner,
            aandeelGOGEWSPartner: aandeelGOGEWSPartner,
            aandeelBox2Partner: aandeelBox2Partner,
            aandeelBox3Partner: aandeelBox3Partner,
            aandeelPGAPartner: aandeelPGAPartner,
            aandeelDividendbelastingPartner: aandeelDividendbelastingPartner,

            aandeelRendementsGrondslagAangever: aandeelRendementsGrondslagAangever,
            aandeelRendementsGrondslagPartner: aandeelRendementsGrondslagPartner,
            totaalRendementsGrondslag: aandeelRendementsGrondslagAangever + aandeelRendementsGrondslagPartner
        });

        this.berekeningFg.patchValue({ verschuldigdeInkomstenbelastingGezamenlijkGekozen: this.totaalVerschuldigdIbOptimaal });

        if (this.gekozenVerdelingFg.valid) {
            const aangeverGekozenEW = this.gekozenVerdelingFg.value['aandeelEigenWoningAangever'] || 0;
            const aangeverGekozenGOGEWS = this.gekozenVerdelingFg.value['aandeelGOGEWSAangever'] || 0;
            const aangeverGekozenBox2 = this.gekozenVerdelingFg.value['aandeelBox2Aangever'] || 0;
            const aangeverGekozenBox3 = this.gekozenVerdelingFg.value['aandeelBox3Aangever'] || 0;
            const aangeverGekozenPGA = this.gekozenVerdelingFg.value['aandeelPGAAangever'] || 0;
            const aangeverGekozenDividendBelasting = this.gekozenVerdelingFg.value['aandeelDividendbelastingAangever'] || 0;
            const totaalEigenwoningVerdeling = this.totaalEigenwoningVerdeling;
            const totaalGOGEWSVerdeling = this.totaalGOGEWSVerdeling;
            const totaalBox2Verdeling = this.totaalBox2Verdeling;
            const totaalBox3Verdeling = this.totaalBox3Verdeling;
            const totaalPGAVerdeling = this.totaalPGAVerdeling;
            const totaalDividendbelastingVerdeling = this.totaalDividendbelastingVerdeling;

            const eigenAangifte = {
                ...this.aangifte,
                verdeling: {
                    ['aandeelEigenWoning']: aangeverGekozenEW,
                    ['aandeelGOGEWS']: aangeverGekozenGOGEWS,
                    ['aandeelBox2']: aangeverGekozenBox2,
                    ['aandeelBox3']: aangeverGekozenBox3,
                    ['aandeelPGA']: aangeverGekozenPGA,
                    ['aandeelDividendbelasting']: aangeverGekozenDividendBelasting,
                    ['aandeelRendementsGrondslag']: aandeelRendementsGrondslagAangever

                },
                partnerAangifte: {
                    ...this.aangifte.partnerAangifte,
                    verdeling: {
                        ['aandeelEigenWoning']: totaalEigenwoningVerdeling - aangeverGekozenEW,
                        ['aandeelGOGEWS']: totaalGOGEWSVerdeling - aangeverGekozenGOGEWS,
                        ['aandeelBox2']: totaalBox2Verdeling - aangeverGekozenBox2,
                        ['aandeelBox3']: totaalBox3Verdeling - aangeverGekozenBox3,
                        ['aandeelPGA']: totaalPGAVerdeling - aangeverGekozenPGA,
                        ['aandeelDividendbelasting']: totaalDividendbelastingVerdeling - aangeverGekozenDividendBelasting,
                        ['aandeelRendementsGrondslag']: aandeelRendementsGrondslagPartner
                    }
                }
            } as Aangifte;
            const aangifteBerekening = this.bokkzIbRekenservice.getIncomeTaxCalculation(eigenAangifte);
            aangifteBerekening.subscribe((aangifteBerekening) => {
                const aangever = aangifteBerekening.verschuldigdeInkomstenbelasting || 0;
                const partner = aangifteBerekening.partnerBerekening?.verschuldigdeInkomstenbelasting || 0;
                this.dataService.updateAangifteBerekening(aangifteBerekening);
                this.totaalVerschuldigdIb = aangever + partner;
                this.berekeningFg.patchValue({
                        verschuldigdeInkomstenbelastingAangeverGekozen: aangever,
                        verschuldigdeInkomstenbelastingPartnerGekozen: partner,
                        verschuldigdeInkomstenbelastingGezamenlijkGekozen: aangever + partner
                    }
                );
                this.dataService.updateHasVerdelingGezien(true);
                this.incomeTaxEntity.aangifte = eigenAangifte;
                this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
            });
        }

    }

    toonVoorstelKnop(): boolean {
        if (this.toonVoorstelTimeout) {
            clearTimeout(this.toonVoorstelTimeout);
        }

        const newValue = (this.gekozenVerdelingFg.get('aandeelEigenWoningAangever')?.value !== 0 && this.gekozenVerdelingFg.get('aandeelEigenWoningAangever')?.value === null) ||
            (this.gekozenVerdelingFg.get('totaalBox2')?.value !== 0 && this.gekozenVerdelingFg.get('aandeelBox2Aangever')?.value === null) ||
            (this.gekozenVerdelingFg.get('totaalBox3')?.value !== 0 && this.gekozenVerdelingFg.get('aandeelBox3Aangever')?.value === null) ||
            (this.gekozenVerdelingFg.get('totaalRendementsGrondslag')?.value !== 0 && this.gekozenVerdelingFg.get('aandeelRendementsGrondslagAangever')?.value === null) ||
            (this.gekozenVerdelingFg.get('totaalPGA')?.value !== 0 && this.gekozenVerdelingFg.get('aandeelPGAAangever')?.value === null) ||
            (this.gekozenVerdelingFg.get('totaalDividendbelasting')?.value !== 0 && this.gekozenVerdelingFg.get('aandeelDividendbelastingAangever')?.value === null);

        // Set met delay
        this.toonVoorstelTimeout = setTimeout(() => {
            this.toonVoorstelKnopValue = newValue;
        }, 300);

        return this.toonVoorstelKnopValue;
    }


    patchAangifteVerdelingUitAangifte() {
        const aandeelEigenWoningAangever = this.incomeTaxEntity.aangifte?.verdeling?.aandeelEigenWoning || 0;
        const aandeelGOGEWSAangever = this.berekening.box1?.opbouwInkomen?.aftrekWegensGeenOfGeringeEigenWoningSchuld || 0;
        const aandeelBox2Aangever = this.incomeTaxEntity.aangifte?.verdeling?.aandeelBox2 || 0;
        const aandeelBox3Aangever = this.incomeTaxEntity.aangifte?.verdeling?.aandeelBox3 || 0;
        const aandeelPGAAangever = this.incomeTaxEntity.aangifte?.verdeling?.aandeelPGA || 0;
        const aandeelDividendbelastingAangever = this.incomeTaxEntity.aangifte?.verdeling?.aandeelDividendbelasting || 0;

        const aandeelEigenWoningPartner = this.incomeTaxEntity.aangifte?.partnerAangifte?.verdeling?.aandeelEigenWoning || 0;
        const aandeelGOGEWSPartner = this.berekening.partnerBerekening?.box1?.opbouwInkomen?.aftrekWegensGeenOfGeringeEigenWoningSchuld || 0;
        const aandeelBox2Partner = this.incomeTaxEntity.aangifte?.partnerAangifte?.verdeling?.aandeelBox2 || 0;
        const aandeelBox3Partner = this.incomeTaxEntity.aangifte?.partnerAangifte?.verdeling?.aandeelBox3 || 0;
        const aandeelPGAPartner = this.incomeTaxEntity.aangifte?.partnerAangifte?.verdeling?.aandeelPGA || 0;
        const aandeelDividendbelastingPartner = this.incomeTaxEntity.aangifte?.partnerAangifte?.verdeling?.aandeelDividendbelasting || 0;

        this.totaalEigenwoningVerdeling = aandeelEigenWoningAangever + aandeelEigenWoningPartner;
        this.totaalGOGEWSVerdeling = aandeelGOGEWSAangever + aandeelGOGEWSPartner;
        this.totaalBox2Verdeling = aandeelBox2Aangever + aandeelBox2Partner;
        this.totaalBox3Verdeling = aandeelBox3Aangever + aandeelBox3Partner;
        this.totaalPGAVerdeling = aandeelPGAAangever + aandeelPGAPartner;
        this.totaalDividendbelastingVerdeling = aandeelDividendbelastingAangever + aandeelDividendbelastingPartner;

        const aandeelRendementsGrondslagAangever = this.aangifte?.verdeling?.aandeelRendementsGrondslag || 0;
        const aandeelRendementsGrondslagPartner = this.aangifte?.partnerAangifte?.verdeling?.aandeelRendementsGrondslag || 0;

        this.gekozenVerdelingFg.patchValue({
            totaalEigenWoning: this.totaalEigenwoningVerdeling,
            totaalGOGEWS: this.totaalGOGEWSVerdeling,
            totaalBox2: this.totaalBox2Verdeling,
            totaalBox3: this.totaalBox3Verdeling,
            totaalPGA: this.totaalPGAVerdeling,
            totaalDividendbelasting: this.totaalDividendbelastingVerdeling,

            aandeelEigenWoningAangever: aandeelEigenWoningAangever,
            aandeelGOGEWSAangever: aandeelGOGEWSAangever,
            aandeelBox2Aangever: aandeelBox2Aangever,
            aandeelBox3Aangever: aandeelBox3Aangever,
            aandeelPGAAangever: aandeelPGAAangever,
            aandeelDividendbelastingAangever: aandeelDividendbelastingAangever,

            aandeelEigenWoningPartner: aandeelEigenWoningPartner,
            aandeelGOGEWSPartner: aandeelGOGEWSPartner,
            aandeelBox2Partner: aandeelBox2Partner,
            aandeelBox3Partner: aandeelBox3Partner,
            aandeelPGAPartner: aandeelPGAPartner,
            aandeelDividendbelastingPartner: aandeelDividendbelastingPartner,

            aandeelRendementsGrondslagAangever: aandeelRendementsGrondslagAangever,
            aandeelRendementsGrondslagPartner: aandeelRendementsGrondslagPartner,
            totaalRendementsGrondslag: aandeelRendementsGrondslagAangever + aandeelRendementsGrondslagPartner

        });
        this.createVerschuldigeIbGekozen();

    }

    private createVerschuldigeIbOptimaal() {
        const partnerOptimaal = this.optimaleBerekening.partnerBerekening?.verschuldigdeInkomstenbelasting || 0;
        const aangeverOptimaal = this.optimaleBerekening?.verschuldigdeInkomstenbelasting || 0;
        this.totaalVerschuldigdIbOptimaal = partnerOptimaal + aangeverOptimaal;
        this.berekeningFg.patchValue({
            verschuldigdeInkomstenbelastingAangeverOptimaal: aangeverOptimaal,
            verschuldigdeInkomstenbelastingPartnerOptimaal: partnerOptimaal,
            verschuldigdeInkomstenbelastingGezamenlijkOptimaal: aangeverOptimaal + partnerOptimaal
        });
    }

    private createVerschuldigeIbGekozen() {
        const partner = this.berekening.partnerBerekening?.verschuldigdeInkomstenbelasting || 0;
        const aangever = this.berekening?.verschuldigdeInkomstenbelasting || 0;
        this.totaalVerschuldigdIb = aangever + partner;
        this.berekeningFg.patchValue({
            verschuldigdeInkomstenbelastingAangeverGekozen: aangever,
            verschuldigdeInkomstenbelastingPartnerGekozen: partner,
            verschuldigdeInkomstenbelastingGezamenlijkGekozen: aangever + partner
        });
    }

    maxEigenWoningValidator() {
        return (control: AbstractControl): ValidationErrors | null => {
            const maxEigenWoning = this.getMaxEigenWoning();
            if (maxEigenWoning > 0) {
                if (control.value < 0) {
                    return { minEigenWoning: 'De waarde is te laag!' };
                } else if (control.value > maxEigenWoning) {
                    return { maxEigenWoning: 'De waarde is te hoog!' };
                }
            } else if (maxEigenWoning < 0) {
                if (control.value > 0) {
                    return { minEigenWoning: 'De waarde is te hoog!' };
                } else if (control.value < maxEigenWoning) {
                    return { maxEigenWoning: 'De waarde is te laag!' };
                }
            }
            return null;
        };
    }

    getMaxEigenWoning(): number {
        return this.totaalEigenwoningVerdeling;
    }

    maxBox2Validator() {
        return (control: AbstractControl): ValidationErrors | null => {
            const maxBox2 = this.getMaxBox2();
            if (maxBox2 > 0) {
                if (control.value < 0) {
                    return { minBox2: 'De waarde is te laag' };
                } else if (control.value > maxBox2) {
                    return { maxBox2: 'De waarde is te hoog' };
                }
            } else {
                if (control.value > 0) {
                    return { minBox2: 'De waarde is te hoog' };
                } else if (control.value < maxBox2) {
                    return { maxBox2: 'De waarde is te laag' };
                }
            }
            return null;
        };
    }

    getMaxBox2(): number {
        return this.totaalBox2Verdeling;
    }

    maxBox3Validator() {
        return (control: AbstractControl): ValidationErrors | null => {
            const maxBox3 = this.getMaxBox3();
            if (control.value < 0) {
                return { minBox3: 'De waarde is te laag' };
            } else if (control.value > maxBox3) {
                return { maxBox3: 'De waarde is te hoog' };
            }
            return null;
        };
    }

    getMaxBox3(): number {
        return this.totaalBox3Verdeling;
    }

    maxBox3RendementsgrondslagValidator() {
        return (control: AbstractControl): ValidationErrors | null => {
            const maxBox3Rendementsgrondslag = this.getMaxBox3Rendementsgrondslag();

            if (control.value < 0) {
                return { minBox3: 'De waarde is te laag' };
            } else if (control.value > maxBox3Rendementsgrondslag) {
                return { maxBox3: 'De waarde is te hoog' };
            }
            return null;
        };
    }

    getMaxBox3Rendementsgrondslag(): number {
        return this.specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value ?? 0;
    }

    maxPGAValidator() {
        return (control: AbstractControl): ValidationErrors | null => {
            const maxPGA = this.getMaxPGA();
            if (control.value < 0) {
                return { minPGA: 'De waarde is te laag' };
            } else if (control.value > maxPGA) {
                return { maxPGA: 'De waarde is te hoog' };
            }
            return null;
        };
    }

    getMaxPGA(): number {
        return this.totaalPGAVerdeling;
    }

    maxDividendBelastingValidator() {
        return (control: AbstractControl): ValidationErrors | null => {
            const maxDividendBelasting = this.getMaxDividendBelasting();
            if (control.value < 0) {
                return { minDividendBelasting: 'De waarde is te laag' };
            } else if (control.value > maxDividendBelasting) {
                return { minDividendBelasting: 'De waarde is te hoog' };
            }
            return null;
        };
    }

    getMaxDividendBelasting(): number {
        return this.totaalDividendbelastingVerdeling;
    }

    private resetVerdelingGekozenFg() {
        this.gekozenVerdelingFg.reset();
        this.gekozenVerdelingFg.controls.aandeelEigenWoningAangever.reset();
        this.gekozenVerdelingFg.controls.aandeelGOGEWSAangever.reset();
        this.gekozenVerdelingFg.controls.aandeelBox2Aangever.reset();
        this.gekozenVerdelingFg.controls.aandeelBox3Aangever.reset();
        this.gekozenVerdelingFg.controls.aandeelDividendbelastingAangever.reset();
        this.gekozenVerdelingFg.controls.aandeelPGAAangever.reset();
        this.gekozenVerdelingFg.controls.aandeelEigenWoningPartner.reset();
        this.gekozenVerdelingFg.controls.aandeelGOGEWSPartner.reset();
        this.gekozenVerdelingFg.controls.aandeelBox2Partner.reset();
        this.gekozenVerdelingFg.controls.aandeelBox3Partner.reset();
        this.gekozenVerdelingFg.controls.aandeelDividendbelastingPartner.reset();
        this.gekozenVerdelingFg.controls.aandeelPGAPartner.reset();
        this.berekeningFg.controls.verschuldigdeInkomstenbelastingAangeverGekozen.reset();
        this.berekeningFg.controls.verschuldigdeInkomstenbelastingPartnerGekozen.reset();
        this.berekeningFg.controls.verschuldigdeInkomstenbelastingGezamenlijkGekozen.reset();
        if (this.incomeTaxEntity && this.incomeTaxEntity.aangifte && this.incomeTaxEntity.aangifte.verdeling) {
            this.incomeTaxEntity.aangifte.verdeling = undefined;
        }
        if (this.incomeTaxEntity && this.incomeTaxEntity.aangifte &&
            this.incomeTaxEntity.aangifte?.partnerAangifte &&
            this.incomeTaxEntity.aangifte.partnerAangifte.verdeling) {
            this.incomeTaxEntity.aangifte.partnerAangifte.verdeling = undefined;
        }
        this.gekozenVerdelingFg.patchValue({
            totaalEigenWoning: this.totaalEigenwoningVerdeling,
            totaalGOGEWS: this.totaalGOGEWSVerdeling,
            totaalBox2: this.totaalBox2Verdeling,
            totaalBox3: this.totaalBox3Verdeling,
            totaalPGA: this.totaalPGAVerdeling,
            totaalDividendbelasting: this.totaalDividendbelastingVerdeling
        });
        this.gekozenVerdelingFg.markAsDirty();
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

    public controleerRendementsGrondslag() {
        const totaal = this.rendementsGrondslagFormGroup.get('rendementsGrondslag')?.value || 0;
        const aangever = this.rendementsGrondslagFormGroup.get('aandeelRendementsGrondslagVoorRegelingenAangever')?.value || 0;
        const partner = this.rendementsGrondslagFormGroup.get('aandeelRendementsGrondslagVoorRegelingenPartner')?.value || 0;

        if (aangever + partner < totaal) {
            return false;
        } else {
            return true;
        }
    }

    public berekenRendementsGrondslagRegelingen() {
        const rendementsGrondslag = this.berekening.box3?.opbouwInkomen?.rendementsGrondslag?.valueOf() || 0;
        const vermogensGrensVoorRegelingen = this.vermogensGrensVoorRegelingen || 0;
        const heffingsvrijVermogen = this.specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'heffingsvrijVermogenAangever'])?.value || 0;
        const saldoGroeneBeleggingen = this.specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'groeneBeleggingen'])?.value || 0;
        const vrijstellingGroeneBeleggingen = this.specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'vrijstellingGroeneBeleggingen'])?.value || 0;


        return rendementsGrondslag > vermogensGrensVoorRegelingen && rendementsGrondslag < (heffingsvrijVermogen * 2);

    }

    public berekenRendementsGrondslagGroeneBeleggingen() {
        const rendementsGrondslag = this.berekening.box3?.opbouwInkomen?.rendementsGrondslag?.valueOf() || 0;
        const vermogensGrensVoorRegelingen = this.vermogensGrensVoorRegelingen || 0;
        const heffingsvrijVermogen = this.specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'heffingsvrijVermogenAangever'])?.value || 0;
        const saldoGroeneBeleggingen = this.specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'groeneBeleggingen'])?.value || 0;
        const vrijstellingGroeneBeleggingen = this.specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'vrijstellingGroeneBeleggingen'])?.value || 0;

        return rendementsGrondslag > vermogensGrensVoorRegelingen && rendementsGrondslag < (heffingsvrijVermogen * 2);
    }
}
